<div class="loader-overlay" *ngIf="isLoading">
  <div class="loader-container">
    <div class="spinner"></div>
    <p class="loader-message">{{ message }}</p>
  </div>
</div>
